import Client from 'config/axios';
import posthog from 'posthog-js';

export const completeSuggestedPost = async (
  token: string,
  id: string,
  points: number
) => {
  const body = {
    status: 'completed',
    points: points,
    message: ''
  };
  const { data } = await Client.post(
    `suggested_post/aprove_reject/${id}`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  posthog.capture('Marcar Propuesta como Completada', {
    CompleteSuggestedPost: data
  });
  return {
    data
  };
};
